"use client";

/* eslint-disable no-console */
import {
  SerializedRequestOptions,
  SerializedResponse,
} from "@faire/next-utils/revealServerFetches/types";
import { useEffect } from "react";

export const RevealServerFetchesConsoleLogging: React.FC<{
  fetches: Array<[SerializedRequestOptions, SerializedResponse<unknown>]>;
}> = ({ fetches }) => {
  useEffect(() => {
    fetches.forEach(([request, response]) => {
      console.groupCollapsed(
        "[Server-side] %s %s status=%s",
        request.method,
        request.url,
        response.status
      );
      console.log(`Request params: %s`, request.params);
      console.log(`Request data: %o`, request.data);
      if ("data" in response) {
        console.log("Response data: %o", response.data);
      } else {
        console.log("Response error: %s", response.error.message);
      }
      console.groupEnd();
    });
  }, [fetches]);

  return null;
};

export const RevealServerFetchesPendingMessage: React.FC<{
  observeFetchTimeout: number;
}> = ({ observeFetchTimeout }) => {
  useEffect(() => {
    console.log(
      `Server-side fetches will be reported in ${observeFetchTimeout} seconds...`
    );
  }, [observeFetchTimeout]);

  return null;
};
